export enum Pages {
    players,
        cards,
        holeAssignments,
        ctps,
        notes,
        scores,
        payouts
}
